(function($) {
  // Ensure the DOM is ready before running any code
  $(document).ready(function() {
    // Check if the collection object is defined and its init method exists
    if (typeof collection !== 'undefined' && typeof collection.init === 'function') {
      collection.init();
    } else {
      console.error('Collection object or its init method is undefined.');
    }
  });

  var collection = {
    // Initialize the collection features
    init: function() {
      this.initCollectionFilter();
      this.initCollectionSorting();
    },

    // Initialize collection filtering
    initCollectionFilter: function() {
      if ($(".engoj-collection-sidebar").length > 0) {
        this.filterParams();
        this.filterMapEvents();
        this.filterMapClear();
        this.filterMapClearAll();
      }
    },

    // Initialize collection sorting
    initCollectionSorting: function() {
      $(".collection-sorting a").click(function(e) {
        e.preventDefault();
        
        // Check if the clicked element is not already active
        if (!$(this).parent().hasClass("active")) {
          // Update query parameters for sorting
          Shopify.queryParams.sort_by = $(this).attr("href");
          collection.filterAjaxClick();    
          
          // Remove active class from all items and add it to the clicked one
          $(".collection-sorting li.active").removeClass("active");
          $(this).parent().addClass("active");
        }
        
        // Update the dropdown label with the selected option's text
        var selected = $(this).text();   
        $(this).closest('.dropdown').find('.dropdown-label').text(selected);
        $(this).closest('.dropdown-content').removeClass('active');

        // Store the selected text in localStorage to persist across page reloads
        localStorage.setItem('selectedSortOption', selected);
      });

      // On page load, check if a sort option was previously selected
      var savedSortOption = localStorage.getItem('selectedSortOption');
      if (savedSortOption) {
        $('.dropdown-label').text(savedSortOption);
      }
    },

    // Helper method to parse URL parameters
    filterParams: function() {
      Shopify.queryParams = {};
      if (location.search.length) {
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }
    },

    // Method to handle AJAX-based filtering
    filterAjaxClick: function(baseLink) {
      delete Shopify.queryParams.page;
      var newurl = this.filterCreateUrl(baseLink);
      this.fillterClick = true;
      History.pushState({
        param: Shopify.queryParams
      }, newurl, newurl);
      this.filterGetContent(newurl);
    },

    // Method to create a new URL based on current query parameters
    filterCreateUrl: function(baseLink) {
      var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');
      if (baseLink) {
        if (newQuery != "")
          return baseLink + "?" + newQuery;
        else
          return baseLink;
      }
      return location.pathname + "?" + newQuery;
    },

    // Method to fetch and update content via AJAX
    filterGetContent: function(newurl) {
      $.ajax({
        type: 'get',
        url: newurl,
        beforeSend: function() {
          showPopup('.loading');
        },
        success: function(data) {
          collection.filterMapData(data);
          collection.filterMapClear();
          hidePopup('.loading');
          hidePopup('.filter-to-left , .js-bg');
        },
        error: function(xhr, text) {
          hidePopup('.loading');
          hidePopup('.filter-to-left, .js-bg');
          $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
          showPopup('.ajax-error-modal');
        }
      });
    },

    // Method to replace content on the page with new data
    filterMapData: function(data) {
      var currentList = $(".grid-uniform");
      var productList = $(data).find(".grid-uniform");
      currentList.replaceWith(productList);

      // Replace pagination
      if ($(".pagination").length > 0) {
        $(".pagination").replaceWith($(data).find(".pagination"));
      }

      $('.filter-blocks').replaceWith($(data).find(".filter-blocks"));
      this.filterMapClear();
      quickView();

      var ajaxCartConfig = {
        cartContainer: '.enj-minicart-ajax',
        addToCartSelector: '.enj-add-to-cart-btn',
        cartCountSelector: '.enj-cartcount',
        cartCostSelector: '.enj-cartcost',
        moneyFormat: null
      };

      jQuery(function($) {
        ajaxCart.init(ajaxCartConfig);
      });
    },

    // Clear filters (other methods not modified)
    filterMapClear: function() {
      $(".filter-tag").each(function() {
        var filterTag = $(this);
        if (filterTag.find("input:checked").length > 0) {
          filterTag.find(".clear").show().click(function(e) {
            var currentTags = [];
            if (Shopify.queryParams.constraint) {
              currentTags = Shopify.queryParams.constraint.split('+');
            }
            filterTag.find("input:checked").each(function() {
              var selectedTag = $(this);
              var tagName = selectedTag.val();
              if (tagName) {
                var tagPos = currentTags.indexOf(tagName);
                if (tagPos >= 0) {
                  currentTags.splice(tagPos, 1);
                }
              }
            });
            if (currentTags.length) {
              Shopify.queryParams.constraint = currentTags.join('+');
            } else {
              delete Shopify.queryParams.constraint;
            }
            collection.filterAjaxClick();
            e.preventDefault();
          });
        }
      });
    },

    // Other necessary methods for handling events, clearing filters, etc.
    filterMapClearAll: function() {
      $("body").delegate('.refined-widgets a.clear-all', 'click', function(e) {
        delete Shopify.queryParams.constraint;
        delete Shopify.queryParams.q;
        collection.filterAjaxClick();
        e.preventDefault();
        $('.filter-tag a:not(".clear"), .filter-tag label').removeClass('active');
      });

      $("body").delegate('.filter-block .clear', 'click', function(e) {
        var currentTags = [];
        var filterTag = $(this).parent().parent();
        if (Shopify.queryParams.constraint) {
          currentTags = Shopify.queryParams.constraint.split('+');
        }
        filterTag.find("input:checked").each(function() {
          var selectedTag = $(this);
          var tagName = selectedTag.val();
          if (tagName) {
            var tagPos = currentTags.indexOf(tagName);
            if (tagPos >= 0) {
              currentTags.splice(tagPos, 1);
            }
          }
        });
        filterTag.find("a").each(function() {
          $(this).removeClass("active");
        });
        if (currentTags.length) {
          Shopify.queryParams.constraint = currentTags.join('+');
        } else {
          delete Shopify.queryParams.constraint;
        }
        collection.filterAjaxClick();
        e.preventDefault();
      });
    },

    filterMapEvents: function() {
      this.fillterTagEvents();
    },

    fillterTagEvents: function() {
      $("body").delegate('.filter-tag a:not(".clear"), .filter-tag label', 'click', function(e) {
        $(this).toggleClass('active');
        var currentTags = [];

        if (Shopify.queryParams.constraint) {
          currentTags = Shopify.queryParams.constraint.split('+');
        }

        if (!window.filter_mul_choice && !$(this).prev().is(":checked")) {
          var otherTag = $(this).parents('.filter-tag').find("input:checked");
          if (otherTag.length > 0) {
            var tagName = otherTag.val();
            if (tagName) {
              var tagPos = currentTags.indexOf(tagName);
              if (tagPos >= 0) {
                currentTags.splice(tagPos, 1);
              }
            }
          }
        }

        var tagName = $(this).prev().val();
        if (tagName) {
          var tagPos = currentTags.indexOf(tagName);
          if (tagPos >= 0) {
            currentTags.splice(tagPos, 1);
          } else {
            currentTags.push(tagName);
          }
        }
        if (currentTags.length) {
          Shopify.queryParams.constraint = currentTags.join('+');
        } else {
          delete Shopify.queryParams.constraint;
        }
        collection.filterAjaxClick();
        e.preventDefault();
      });
    }
  };
})(jQuery);
